<template>
  <div class="min-h-80 p-2 bg-gray-200 dark:bg-gray-900">
    <zoneEditModal v-if="selected" :detail="selected" @refresh="getAll()" />
    <zoneAddModal @refresh="getAll()"/>
    <zoneVehiclesModal :detail="selected"/>
    <!-- Loading Indicator -->

    <!-- <div v-if="load" class="w-full h-96 flex items-center justify-center">
      <i class="fas fa-spinner fa-3x text-gray-400 fa-spin"></i> 
    </div> -->
    <logModule :moduleId="24" :rowId="selected.id" />
    <div   class="h-full p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm">
      <div class="w-full">
        <LyrausTable
          :data="List"
          :columns="columns"
          :enablePagination="true"
          :searchBar="true"
          :searchProp="search"
          @update-search-value="(val) => handleSearchValue(val)"
          :handleSearch="handleSearch"
          :isLoading="load"
          :pageCount="pageCount"
          :pageProp="currentPage"
          @update-current-page="handleCurrentPage"
          :totalCount="totalCount"
          :alternateRowBg="['white', 'gray-100']"
          :batchOperations="true"
          :rightExtraSlot="true"
          :buttonsColumn="{ label: 'İşlem' }"
          :paginationButtonColor="'red-600'"
          :paginationHoverColor="'red-700'"
          :containerClass="'p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm'"
          :innerThClass="'py-2 text-left text-xxs font-medium bg-red-300 tracking-wider border-gray-200'"
          :innerTdClass="'whitespace-nowrap text-xxs bg-red-200 py-2'"
        >
          <template v-slot:searchBar> <SearchInput :value="search" :isFull="true" @searcing="(val) => {handleSearchValue(val); handleSearch();}" /> </template>
          <template v-slot:colButtons="{ item }">
            <div class="flex items-center justify-end space-x-2 px-2">
              <button
                @click="showLogModal(item)"
                class=" flex items-center justify-center"
                type="button"
              >
                <!-- bg-white shadow rounded-md border-gray-400 -->
                <img
                  title="Aksiyon geçmişini buradan takip edebilirsiniz."
                  class="w-4 h-3.5"
                  src="@/assets/log/logikon.png"
                  alt=""
                />
              </button>
              <button class="mr-2" @click="showVehicleModal(item)">
                <i class="fas fa-search"></i>
              </button>
              <button class="mr-2" @click="showEditModal(item)">
                <i class="fas fa-pen text-gray-700"></i>
              </button>
              <button class="mr-2" @click="deleteModal(item)">
                <i class="fas fa-trash text-gray-700"></i>
              </button>
            </div>
          </template>
          <template v-slot:rowButtons="{ item, columnKey }">
            <div v-if="columnKey === 'polyline'">
              <i v-if="item.polyline" class="fas fa-check text-green-400"></i>
              <i v-else class="fas fa-times text-red-400"></i>
            </div>
            <div v-if="columnKey === 'vehicleTypes'" class="flex items-center space-x-1">
              <span v-if="item.countOzmal === 1" 
                class="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800 whitespace-nowrap">
                <i class="fas fa-truck mr-1"></i>Özmal
              </span>
              <span v-if="item.countRental === 1" 
                class="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800 whitespace-nowrap ml-1">
                <i class="fas fa-handshake mr-1"></i>Kiralık
              </span>
              <span v-if="item.countOzmal !== 1 && item.countRental !== 1" 
                class="px-2 py-1 text-xs rounded-full bg-red-100 text-red-800 whitespace-nowrap">
                <i class="fas fa-exclamation-triangle mr-1"></i>Hiçbiri
              </span>
            </div>
            <div v-if="columnKey === 'polygonType'" class="flex">
              {{ item.polygonType }}
              <span v-if="item.polygonType === 1" class="ml-2 px-2 py-1 text-xs rounded-full bg-yellow-100 text-yellow-800 whitespace-nowrap">
                <i class="fas fa-clock mr-1"></i>Bekleme Noktası
              </span>
              <span v-else-if="item.polygonType === 2" class="ml-2 px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800 whitespace-nowrap">
                <i class="fas fa-tint mr-1"></i>Yıkama Noktası
              </span>
              <span v-else-if="item.polygonType === 3" class="ml-2 px-2 py-1 text-xs rounded-full bg-green-100 text-green-800 whitespace-nowrap">
                <i class="fas fa-shipping-fast mr-1"></i>Sevkiyat Noktası
              </span>
              <span v-else class="ml-2 px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-800 whitespace-nowrap">
                Tanımsız
              </span>
            </div>
          </template>
          <template v-slot:batchOperations>
            <div class="w-full ml-2">
              <asyncBtn
                icon="fas fa-file-excel"
                text="Excel Çıktısı Al"
                loadTitle="Yükleniyor"
                :loadState="load"
                class="w-full md:w-40 bg-green-700"
                size="py-2 px-2"
                type="button"
                @click="excelExport()"
              />

              <asyncBtn
                icon="fas fa-map-marker"
                text="Yeni Bölge"
                loadTitle="Yükleniyor"
                :loadState="load"
                class="w-full md:w-40 bg-red-700"
                size="py-2 px-2 ml-2"
                type="button"
                @click="openNewModal()"
              />
            </div>
          </template>
        </LyrausTable>
      </div>
    </div>
  </div>
</template>

<script>
import logBtn from "../../../components/modals/logModule/logBtn.vue";
import logModule from "../../../components/modals/logModule/index.vue";

import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
// Global Components
import asyncBtn from "@/components/general/asyncBtn.vue";
import SearchInput from "@/components/general/search-input.vue";
// Networking
import axios from "axios";
import { routeZone } from "@/networking/urlmanager";

// Local Components
import zoneEditModal from "./components/zoneEditModal.vue";
import zoneAddModal from "./components/zoneAddModal.vue";
import zoneVehiclesModal from "./components/zoneVehicles.vue";

export default {
  name: "branches-module",
  components: {
    asyncBtn,
    zoneEditModal,
    zoneAddModal,
    zoneVehiclesModal,
    SearchInput,
    logBtn,logModule
  },
  data() {
    return {
      load: false,
      search: "",
      selected: { id: "" },
      List: [],
      excelList: [],
      totalCount: 0,
      pageCount: 1,
      currentPage: 0,
      columns: [
        {
          key: "id",
          label: "ID",
        },
        {
          key: "name",
          label: "Bölge Adı",
        },
        {
          key: "polygonTypeName",
          label: "Bölge Tipi",
        },
        {
          key: "vehicleTypes",
          label: "Dahil Edilen Araçlar",
        },
        {
          key: "address",
          label: "Adres",
        },
        {
          key: "polyline",
          label: "Bölge",
          dontDisplay: true,
          center: true,
        },
      ],
    };
  },
  methods: {
    showLogModal(item) {
      this.selected = item;
      setTimeout(() => {
        this.$modal.show('log');
      }, 100);
    },
    showEditModal(item) {
      this.selected = item;
      setTimeout(() => {
        this.$modal.show("route-report-modal");
      }, 100);
    },
    showVehicleModal(item) {
      this.selected = item;
      setTimeout(() => {
        this.$modal.show("zone-vehicles-modal");
      }, 100);
    },
    deleteModal(item) {
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        "Bölgeyi silmek istediğinize emin misiniz?",
        true,
        this.$t("general.confirmText"),
        this.$t("general.rejectText")
      ).then((result) => {
        if (result.isConfirmed) {
          this.load = true;
          axios
            .post(
              routeZone.delete,
              {
                rowId: item.id,
              },
              {
                headers: {
                  Authorization: "Bareer " + this.$store.state.userData.token,
                },
              }
            )
            .then(() => {
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "",
                false,
                this.$t("general.OkayTitle")
              );
            })
            .catch((err) => {
              this.errorBox(err.response);
            })
            .finally(() => {
              this.load = false;
              this.getAll();
            });
        }
      });
    },

    openNewModal() {
      this.$modal.show("zone-creation-modal");
    },
    handleSearch() {
      this.clickSearch = false;
      this.searchColumn = "";
      this.currentPage = 0;
      this.getAll();
    },
    handleCurrentPage(val) {
      this.currentPage = val;
    },
    handleSearchValue(val) {
      this.search = val;
    },
    getAll() {
      this.List = [];
      this.load = true;
      const params = {
        page: this.currentPage,
        search: this.search,
      };
      axios
        .get(routeZone.getAll, {
          params,
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          this.List = res.data.data.detail.map(item=>{
             let polygonTypeName = "Tanımsız";
            if (item.polygonType === 1) polygonTypeName = "Bekleme Noktası";
            else if (item.polygonType === 2) polygonTypeName = "Yıkama Noktası";
            else if (item.polygonType === 3) polygonTypeName = "Sevkiyat Noktası";

            return {
              ...item,
              polygonTypeName
            }
          });


          this.totalCount = res.data.data.totalCount;
          this.pageCount = res.data.data.pageCount;
        })
        .catch((err) => {
          this.errorBox(err.response);
        })
        .finally(() => {
          this.load = false;
        });
    },

    refreshZones() {
      this.List = [];
      this.load = true;

      axios
        .get(routeZone.refresh, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          },
        })
        .then(() => {
          this.getAll();
        })
        .catch((err) => {
          this.errorBox(err.response);
        });
    },

    getExcelData() {
      const params = {
        search: this.search,
      };

      // Return the Promise from axios
      return axios
        .get(routeZone.getAllData, {
          params,
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token, // Fixed typo in "Bearer"
          },
        })
        .then((res) => {
          return res.data.data; // This will now be properly returned
        })
        .catch((err) => {
          this.errorBox(err.response);
          return []; // Return empty array in case of error
        })
        .finally(() => {
          this.load = false;
        });
    },

    async excelExport() {
      try {
        const workbook = XLSX.utils.book_new();

        const headers = {
          id: "ID",
          name: "Bölge Adı",
          polygonType: "Bölge Tipi",
          countOzmal: "Özmal Araçlar Dahil",
          countRental: "Kiralık Araçlar Dahil",
          address: "Adres",
          latitude: "Enlem",
          longitude: "Boylam",
          polyline: "Bölge Tanımlı"
        };

        const excelData = await this.getExcelData();

        if (!excelData || !Array.isArray(excelData)) {
          throw new Error("Invalid data received");
        }

        // Create worksheet data with headers and rows
        const worksheet = XLSX.utils.aoa_to_sheet([
          Object.values(headers), // Headers row
          ...excelData.map((item) => {
            // Bölge tipi adını hesapla
            let polygonTypeName = "Tanımsız";
            if (item.polygonType === 1) polygonTypeName = "1 - Bekleme Noktası";
            else if (item.polygonType === 2) polygonTypeName = "2 - Yıkama Noktası";
            else if (item.polygonType === 3) polygonTypeName = "3 - Sevkiyat Noktası";
            
            return [
              item.id || "",
              item.name || "",
              polygonTypeName,
              item.countOzmal === 1 ? "Evet" : "Hayır",
              item.countRental === 1 ? "Evet" : "Hayır",
              item.address || "",
              item.latitude || "",
              item.longitude || "",
              item.polyline ? "Var" : "Yok",
            ];
          }),
        ]);

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "BölgeRaporu");

        // Create and save the file
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });

        const data = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(data, "bolge-raporu.xlsx");
      } catch (error) {
        console.error("Excel export failed:", error);
        // Handle error appropriately (maybe show an error message to user)
        if (this.errorBox) {
          this.errorBox(error);
        }
      }
    },
  },
  created() {
    this.getAll();
  },
  watch: {
    currentPage() {
      this.getAll();
    },
  },
};
</script>
